import React from "react";
import { Container } from "reactstrap";


function TopRangeFeedbackForm() {

  return (
    <Container >

      <script src="https://forms.yandex.ru/_static/embed.js"></script>

      <div className="mb-4">
        <h2 style={{color: "#dc0000", marginTop: "150px"}}>Обратная связь</h2>
      </div>

      <p>
        TopRange оказывает комплексную поддержку по лифтовому и эскалаторному оборудованию. 
      </p>

      <p>
        Пожалуйста, оставьте сообщение и свои контактные данные, чтобы мы могли связаться с вами.
      </p>

      <div>
        <iframe
          title="Обратаня связь"
          src="https://forms.yandex.ru/u/679396be068ff083f91e30ea/?iframe=1" 
          frameborder="0" 
          name="ya-form-679396be068ff083f91e30ea" 
          height="400"
          width="100%"
        >
        </iframe>
      </div>
      
    </Container>
  )
}

export default TopRangeFeedbackForm;